import { IconButton } from '@dealstack/frontend/shared/components/fundament/IconButton/IconButton';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import styled from 'styled-components';

export const HelpButton = styled(
	({ className, onClick }: { className?: string; onClick?: () => void }) => {
		const tMipCreate = useTranslationMipCreate();

		return (
			<div onClick={onClick} className={`${className} clickAnimation`}>
				<IconButton icon="help" size="md" variant="outlined" />
				<Text bold variant="button">
					{tMipCreate('sidebar.help_guide')}
				</Text>
			</div>
		);
	}
)`
	display: flex;
	align-items: center;
	cursor: pointer;

	${Text} {
		padding-left: 0.5rem;
		color: ${({ theme }) => theme.v2.color.secondary[1000]};
	}

	${IconButton} {
		--background: transparent;
		border-color: ${({ theme }) => theme.v2.color.secondary[1000]};

		.svg {
			--color: ${({ theme }) => theme.v2.color.secondary[1000]};
		}
	}
`;
